import React, { useEffect, useState } from "react";
import free from "../../assets/pricing/free.png";
import basic from "../../assets/pricing/basic.png";
import pro from "../../assets/pricing/pro.png";
import pro_plus from "../../assets/pricing/pro_plus.png";
import unlimited from "../../assets/pricing/unlimited.png";
import { IconsMajor, MobileAcceptMajor } from "@shopify/polaris-icons";
const pricingTableData = {
	general: [
		{
			name: "free",
			display_name: "STARTER",
			description: "Best for Entrepreneur",
			src: free,
			price: "$0",
			priceYearly: "Free",
			total: "$0",
			save: "$0",
			save_per: "0",
		},
		{
			name: "basic",
			display_name: "BASIC",
			description: "Best for small business",
			src: basic,
			price: "$6.99",
			priceYearly: "$4.89",
			total: "$67.1",
			save: "$16.78",
			save_per: "30%",
		},
		{
			name: "pro",
			display_name: "PRO",
			description: "Best for medium business",
			src: pro,
			price: "$9.99",
			priceYearly: "$6.99",
			total: "$95.9",
			save: "$24",
			save_per: "30%",
		},

		{
			name: "pro_plus",
			display_name: "PRO PLUS",
			description: "Best for large business",
			src: pro_plus,
			price: "$24.99",
			priceYearly: "$17.49",
			total: "$209.9",
			save: "$90",
			save_per: "30%",
		},
		{
			name: "unlimited",
			display_name: "UNLIMITED",
			description: "Best for Shopify Plus",
			src: unlimited,
			price: "$39.99",
			priceYearly: "$27.99",
			total: "$335.9",
			save: "$143.9",
			save_per: "30%",
		},
		// {
		//   name: "pro_plus",
		//   src: pro_plus,
		//   price: "$15.99",
		//   priceYearly: "$7.99",
		//   total: "$95",
		//   save: "$95",
		//   save_per: "50",
		// },
		// {
		//   name: "unlimited",
		//   src: unlimited,
		//   price: "$34.99",
		//   priceYearly: "$17.49",
		//   total: "$210",
		//   save: "$210",
		//   save_per: "50",
		// },
	],
	content: [
		{
			count: [
				"<p><strong>30</strong> synced orders/month</p>",
				"<p><strong>500</strong> synced orders/month</p>",
				"<p><strong>6,000 </strong> synced orders/month</p>",
				"<p><strong>25,000</strong> synced orders/month</p>",
				"<p><strong>Unlimited</strong> synced orders/month</p>",
			],
		},
		{
			count: [
				"<p><strong>Unlimited</strong> PayPal Accounts</p>",
				"All Free features +",
				"All Basic features +",
				"All Pro features +",
				"All Pro Plus features +",
			],
		},
		{
			count: [
				"Sync previous orders",
				"1 Stripe Account",
				"Unlimited Stripe Account",
				"<p>Multi-store: <strong>3 stores</strong>",
				"<p>Multi-store: <strong>4+ stores</strong>",
			],
		},
		{
			count: [
				"Auto-matching courier",
				"<p>Courier matching rule: <strong>2 rules</strong></p>",
				"<p>Courier matching rule: <strong>10 rules</strong></p>",
				"<p>Courier matching rule: <strong>unlimited rules</strong></p>",
				"PCI & SOC2 Compliance",
			],
		},
		{
			count: [
				"",
				"Sync Digital Product",
				"Premium processing data",
				"Premium Priority Sync",
				"Dedicated sync cluster",
			],
		},

		{
			count: [
				"",
				"",
				"<p>Multi-store: <strong>2 stores</strong></p>",
				"",
				"",
			],
		},
	],
};
export default pricingTableData;
